import { render } from "./PriceField.vue?vue&type=template&id=b1dde886"
import script from "./PriceField.vue?vue&type=script&lang=js"
export * from "./PriceField.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__